'use client';

import { createContext, ReactNode, useContext } from 'react';

type MessagesByLocale = Record<string, Record<string, unknown>>;

const LocaleMessagesContext = createContext<MessagesByLocale>({});

interface LocaleMessagesProviderProps {
  children: ReactNode;
  messagesByLocale: MessagesByLocale;
}

export function LocaleMessagesProvider({
  children,
  messagesByLocale,
}: LocaleMessagesProviderProps) {
  return (
    <LocaleMessagesContext.Provider value={messagesByLocale}>
      {children}
    </LocaleMessagesContext.Provider>
  );
}

export function useLocaleMessages(): MessagesByLocale {
  return useContext(LocaleMessagesContext);
}
